import moment from 'moment';
import { useAppData } from '../../../../context/AppDataContext';
import ProfileEditor from '../component/ProfileEditor';
import AppLayout from '../../../../layout/components/AppLayout';
import { Link } from 'react-router-dom';

const LabelValue = ({label,value}) =>{
    return (
        <div className='row mb-3'>
            <div className='col-md-6'><span className='fw-bold'>{label}</span></div>
            <div className='col-md-6'>{value}</div>
        </div>
    )
}

function ProfilePage() {
    const {associateProfile} = useAppData()

    return (
        <AppLayout>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        {associateProfile &&
                            <div className='card'>
                                <div className='Card-header'></div>
                                <div className='card-body'>
                                    <LabelValue label="Reg. Phone" value={associateProfile.phone} />
                                    <ProfileEditor fieldName="firstName" fieldType="text" label="Name" value={associateProfile.firstName} />
                                    <ProfileEditor fieldName="email" fieldType="email" label="Email" value={associateProfile.email} />
                                    <ProfileEditor fieldName="address" fieldType="text" label="Address" value={associateProfile.address} />
                                    <LabelValue label="Member Sience" value={ moment(associateProfile.created_at).format("LL")} />
                                    <LabelValue label="Valid Till" value={ moment(associateProfile.validTill).format("lll")} />
                                    <LabelValue label="Plan" value={ associateProfile.planTitle} />
                                </div>
                            </div>
                        }
                    </div>
                    <div className='col-md-12 mt-2'>
                        <Link className='btn btn-primary' to={"/profile/associated-clinic"}>Associated Clinic List</Link>
                    </div>
                </div>
            </div>
        
        </AppLayout>
    )
}

export default ProfilePage